(() => {
  const icon = document.getElementById('dietxp-favicon');
  if (!icon || icon.dataset.initialized) return;
  icon.dataset.initialized = 'true';
  const motions = [{"name":"Smile & wink","duration":4800,"turn":[[0,[0,0,0,1,1,1]],[0.1,[0,0,0,1,1,1]],[0.32,[90,0,0,1,1,1]],[0.62,[90,0,0,1,1,1]],[0.86,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye2":[[0,[0,0,0,1,1,1]],[0.4,[0,0,0,1,1,1]],[0.46,[0,0,0,0.12,1,1]],[0.49,[0,0,0,0.12,1,1]],[0.54,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]]},{"name":"Friendly nod","duration":3200,"turn":[[0,[0,0,0,1,1,1]],[0.14,[0,0,0,1,1,1]],[0.34,[8,0,0,1,1,1]],[0.55,[-3,0,0,1,1,1]],[0.78,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye1":[[0,[0,0,0,1,1,1]],[0.29,[0,0,0,1,1,1]],[0.34,[0,0,0,1,0.15,1]],[0.37,[0,0,0,1,0.15,1]],[0.43,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye2":[[0,[0,0,0,1,1,1]],[0.29,[0,0,0,1,1,1]],[0.34,[0,0,0,1,0.15,1]],[0.37,[0,0,0,1,0.15,1]],[0.43,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]]},{"name":"Energy hop","duration":3600,"turn":[[0,[0,0,0,1,1,1]],[0.12,[0,0,0,1,1,1]],[0.26,[-2,0,-28,1,1,1]],[0.42,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye1":[[0,[0,0,0,1,1,1]],[0.12,[0,0,0,1,1,1]],[0.26,[0,0,-90,1.06,0.94,1]],[0.36,[0,0,5,0.96,1.04,1]],[0.42,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye2":[[0,[0,0,0,1,1,1]],[0.24,[0,0,0,1,1,1]],[0.39,[0,0,-90,1.06,0.94,1]],[0.49,[0,0,5,0.96,1.04,1]],[0.55,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]]},{"name":"Focus scan","duration":4000,"eye1":[[0,[0,0,0,1,1,1]],[0.12,[0,0,0,1,1,1]],[0.34,[0,380,60,0.72,0.72,1]],[0.44,[0,380,60,0.9,0.9,1]],[0.57,[0,380,60,0.72,0.72,1]],[0.88,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye2":[[0,[0,0,0,1,1,1]],[0.18,[0,0,0,1,1,1]],[0.4,[0,380,-60,0.72,0.72,1]],[0.5,[0,380,-60,0.9,0.9,1]],[0.63,[0,380,-60,0.72,0.72,1]],[0.92,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]]},{"name":"Clean reveal","duration":3200,"turn":[[0,[0,0,0,1,1,1]],[0.14,[-4,-40,0,0.94,0.94,0.35]],[0.4,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye1":[[0,[0,0,0,1,1,1]],[0.14,[0,0,-45,1,1,0.2]],[0.45,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]],"eye2":[[0,[0,0,0,1,1,1]],[0.2,[0,0,-45,1,1,0.2]],[0.55,[0,0,0,1,1,1]],[1,[0,0,0,1,1,1]]]}];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const staticUrl = icon.dataset.staticUrl;
  const rest = [0, 0, 0, 1, 1, 1];
  const cycleLength = motions.reduce((sum, motion) => sum + motion.duration + 1200, 0);
  const frameInterval = 125;
  const cache = new Map();
  let source, parts, timer, started, running = false;

  function at(keys, progress) {
    if (!keys) return rest;
    let i = 1;
    while (i < keys.length - 1 && progress > keys[i][0]) i++;
    const [start, a] = keys[i - 1], [end, b] = keys[i];
    const value = Math.max(0, Math.min(1, (progress - start) / (end - start)));
    const ease = value * value * (3 - 2 * value);
    return a.map((n, j) => n + (b[j] - n) * ease);
  }

  function locate(elapsed) {
    let time = elapsed % cycleLength;
    for (let index = 0; index < motions.length; index++) {
      if (time < 1200) return { index, progress: 0, resting: true, remaining: 1200 - time };
      time -= 1200;
      if (time < motions[index].duration) return { index, progress: time / motions[index].duration, resting: false };
      time -= motions[index].duration;
    }
  }

  function apply(part, values) {
    const [r, x, y, sx, sy, opacity] = values;
    const cx = Number(part.dataset.cx), cy = Number(part.dataset.cy);
    const round = value => Number(value.toFixed(3));
    part.setAttribute('transform', `translate(${round(cx + x)} ${round(cy + y)}) rotate(${round(r)}) scale(${round(sx)} ${round(sy)}) translate(${-cx} ${-cy})`);
    part.setAttribute('opacity', round(opacity));
  }

  function restore() {
    if (icon.getAttribute('href') !== staticUrl) icon.setAttribute('href', staticUrl);
    icon.dataset.motion = 'rest';
  }

  function tick() {
    if (!running) return;
    const position = locate(performance.now() - started);
    if (position.resting) {
      restore();
      timer = setTimeout(tick, Math.max(20, position.remaining));
      return;
    }
    const motion = motions[position.index];
    const frame = Math.round(position.progress * motion.duration / frameInterval);
    const key = `${position.index}:${frame}`;
    if (!cache.has(key)) {
      const progress = Math.min(1, frame * frameInterval / motion.duration);
      apply(parts.turn, at(motion.turn, progress));
      apply(parts.eye1, at(motion.eye1, progress));
      apply(parts.eye2, at(motion.eye2, progress));
      cache.set(key, 'data:image/svg+xml,' + encodeURIComponent(new XMLSerializer().serializeToString(source)));
    }
    if (icon.getAttribute('href') !== cache.get(key)) icon.setAttribute('href', cache.get(key));
    icon.dataset.motion = motion.name;
    timer = setTimeout(tick, frameInterval);
  }

  function sync() {
    clearTimeout(timer);
    running = Boolean(source) && !document.hidden && !reduced.matches;
    if (!running) { restore(); return; }
    started = performance.now();
    tick();
  }

  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  window.addEventListener('pagehide', () => { running = false; clearTimeout(timer); restore(); });
  window.addEventListener('pageshow', sync);
  if (reduced.matches) restore();
  fetch(staticUrl, { credentials: 'omit', cache: 'force-cache' })
    .then(response => { if (!response.ok) throw new Error('Favicon unavailable'); return response.text(); })
    .then(text => {
      source = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
      parts = { turn: source.querySelector('#dxf-turn'), eye1: source.querySelector('#dxf-eye-one'), eye2: source.querySelector('#dxf-eye-two') };
      if (source.localName !== 'svg' || Object.values(parts).some(part => !part)) throw new Error('Invalid favicon SVG');
      source.setAttribute('width', '64');
      source.setAttribute('height', '64');
      sync();
    }).catch(() => { running = false; source = null; restore(); });
})();
